import React from 'react'
import './BaseSkeleton.css'

const BaseSkeletonLoader = ({ type }) => {
  const classes = `skeleton ${type}`
  return <div className={classes}></div>
}

export default BaseSkeletonLoader
